<template>
  <div>
    <div v-if="rating" class="columns is-gapless is-multiline is-centered is-mobile mb-0">
      <div class="column is-narrow">
        <p><b>Rating: {{rating.toFixed(1)}}</b></p>
      </div>
      <div class="column is-narrow ml-2">
        <RatingStars :rating="Math.floor(rating)" />
      </div>
      <div class="column is-narrow ">
        <p>(<b>{{reviews_number}}</b>)</p>
      </div>
    </div>
    <div v-else class="columns is-gapless is-centered is-mobile mb-0">
      <div class="column">
        <p class="is-size-4"><b>No reviews. Be the first!</b><i class="fas fa-arrow-circle-right rightArrow" @click="goToCreateReview()"></i></p>
      </div>
    </div>
  </div>
</template>

<script>
import RatingStars from "../atoms/RatingStars.vue";
export default {
  components: {
    RatingStars
  },
  methods:{
    goToCreateReview(){
      if(this.$route.name !== "gym"){
        this.$router.push(`/gym/${this.gym_id}/#create-review-button`);
      } else {
        this.$emit('scrollToCreate');
      }
    }
  },
  props: {
    rating: Number,
    reviews_number: Number,
    gym_id: Number
  }
};
</script>

<style scoped>

i {
  padding: 0.25rem;
}

.rightArrow {
  color: #00c5fd; 
  cursor: pointer;
}

</style>